import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";

import Layout from "../../components/Layout";
import List from "./List";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});

const View = observer(
  class ServerList extends React.Component {
    render() {
      return (
        <Layout>
          <List></List>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
